/* global dataLayer */

module.exports = {
  track: page => {
    dataLayer.push({ page_virtualName: page, event: 'gtm.view' })
  },
  event: (name, data) => {
    const dataLayerEventData = data || {}
    dataLayerEventData.event = name
    dataLayer.push(dataLayerEventData)
  }
}
